"use strict";

import BaseProxyAcquisition from "@/proxies/base-proxy-acquisition";

/**
 * @class AuthLoginProxy
 * @description Class used for authenticating with the login API V2.
 * @author Laurence A.
 * @version 1.0
 * @since March 1, 2023
 */
export default class AuthLoginProxy {
  /**
   * @async
   * @function execute
   * @description Method used for authenticating users.
   * @param {Object} input - Input paramaters.
   * @param {String} input.username - Email that will be used for authentication.
   * @param {String} input.password - Password that will be used for authentication.
   */
  async execute(input = {}) {
    const baseProxy = new BaseProxyAcquisition();
    const backendUrl = await baseProxy.getBackendUrl();
    const endpointUrl = `${backendUrl}/auth/login`;
    return baseProxy.postData(endpointUrl, input);
  }
}
